import { Base } from '@testsigma/organism';
import { deserialize, serializable } from 'serializr';
import { Platform } from '../enums/platform.enum';

export class PlatformDevice extends Base {
  @serializable
  @serializable
  osName: string;
  @serializable
  osVersion: string;
  @serializable
  platform: Platform;
  @serializable
  displayName: string;
  @serializable
  name: string;
  @serializable
  lambdaTestSupported: boolean;
  @serializable
  lambdaTestName: string;
  @serializable
  kobitonSupported: boolean;
  @serializable
  isAvailable: boolean;
  @serializable
  isRealDevice: boolean;
  @serializable
  isWildCardDevice: boolean;
  @serializable
  browserStackSupported: boolean;
  @serializable
  resolution: string;
  @serializable
  scalingFactor: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(PlatformDevice, input));
  }
}
